import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from '../../vars/ThemeOptions'

const Styled = {}
Styled.H6 = styled.h6`
text-align: center;
&.white {
    color: ${Theme.hex("white")};
}
`

export const H6 = ({children, white}) => {
    const _classname = white ? ['white'] : ['black'];
    _classname.push('thr-h6')
    return <Styled.H6 className={_classname.join(" ")}>{children}</Styled.H6>
}

H6.defaultProps = {
    white: false
}

H6.propTypes= {
    children: PropTypes.node.isRequired,
    white: PropTypes.bool
}